class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();

    /* perf 2026-10 D-12 (pakiet 2): zawartość pustej szuflady (2 obrazy + 4 karty „Dopełnij zestaw”, ~250 elementów) przychodzi
       jako <template data-sv-empty-content> i trafia do DOM w wolnej chwili po załadowaniu strony, najpóźniej przy otwarciu.
       Wygląd bez zmian; Langify (EU) i Judge.me przetwarzają ją w tle, zanim klientka otworzy szufladę. Po przerysowaniu
       (np. usunięcie ostatniej pozycji przy otwartej szufladzie) szablon wstawia się od razu. */
    const later = () => {
      if (this.svEmptyScheduled) return;
      this.svEmptyScheduled = true;
      const run = () => {
        this.svEmptyScheduled = false;
        this.materializeEmpty();
      };
      if (window.requestIdleCallback) requestIdleCallback(run, { timeout: 3000 });
      else setTimeout(run, 1500);
    };
    if (document.readyState === "complete") later();
    else window.addEventListener("load", later, { once: true });
    new MutationObserver(() => {
      if (!this.querySelector("template[data-sv-empty-content]")) return;
      // T6: pod szkieletem B-20 (sv-atc-pending) pusta treść jest zakryta - wstawia się w wolnej chwili, nie od razu
      if (this.classList.contains("active") && !this.classList.contains("sv-atc-pending")) this.materializeEmpty();
      else later();
    }).observe(this, { childList: true, subtree: true });
  }

  materializeEmpty() {
    const tpl = this.querySelector("template[data-sv-empty-content]");
    if (!tpl) return;
    tpl.replaceWith(tpl.content.cloneNode(true));
    if (window.jdgm && typeof jdgm.allBadgesRecall === "function") {
      requestAnimationFrame(() =>
        setTimeout(() => {
          try {
            jdgm.allBadgesRecall();
          } catch (e) {}
        }, 0)
      );
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;

    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    /* K2 (10.10, lab A/B /cart): zmiany zrobione na stronie /cart przy zamkniętej szufladzie czekają na otwarcie (cart.js
       svRefreshDrawer) - rysujemy je tu, przed pierwszą klatką otwarcia, zamiast po każdej zmianie w tle */
    if (this.svPending) {
      const svPaint = this.svPending;
      this.svPending = null;
      svPaint();
    }
    /* perf 2026-10 D-12: pusta szuflada gotowa przed pierwszą klatką otwarcia. T6 (01.10): przy optymistycznym otwarciu po
       „Dodaj do koszyka” (B-20, klasa sv-atc-pending) pustą treść zakrywa szkielet, więc jej ~250 elementów nie wchodzi
       w zadanie kliknięcia (dotąd tak było, gdy klientka kliknęła przed wolną chwilą po załadowaniu); wstawi ją wolna chwila. */
    if (!this.classList.contains("sv-atc-pending")) this.materializeEmpty();
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    /* BUG-overlay 30.09: uchwyt zaplanowanego otwarcia — close() go kasuje, więc otwarcie zaplanowane przed zamknięciem
       nie otworzy szuflady po nim (wcześniej open() + close() w jednym zadaniu kończyło się otwartą szufladą) */
    clearTimeout(this.svOpenTimer);
    this.svOpenTimer = setTimeout(() => {
      this.svOpenTimer = null;
      this.closeHeaderMenu(); // OBS-1 30.09: otwarte menu nagłówka zamyka się razem z otwarciem koszyka (ta sama fala stylów)
      /* perf 2026-10 B-25 (pakiet 2): blokada przewijania w tym samym zadaniu co klasy otwarcia — jedna fala przeliczenia
         stylów zamiast dwóch (wcześniej klasa na <body> szła synchronicznie w open(), a klasy szuflady w osobnym zadaniu).
         Pomiar 30.09 (CPU 4×, telefon, przebiegi przeplatane): szuflada widoczna po open() o 19–51 ms szybciej, p < 0,05. */
      /* K2 (10.10, d-skok): blokada przewijania chowa pasek przewijania i strona przeskakuje w bok o jego szerokość
         (Windows ok. 17 px). Odstęp z prawej o tę samą szerokość na czas otwarcia (wzór okien dialogowych Bootstrap);
         scrollbar-gutter odpada, bo ucinał prawą krawędź szuflady. Telefony: pasek nakładany, szerokość 0 - bez zmian. */
      const svScrollbar = window.innerWidth - document.documentElement.clientWidth;
      if (svScrollbar > 0 && !document.body.classList.contains("overflow-hidden")) {
        document.body.style.paddingRight = svScrollbar + "px";
        this.svPadded = true;
      }
      /* K2 (10.10, m-pomiar): otwarcie szuflady - ikoną koszyka (na /cart: cart_page) albo po „Dodaj do koszyka” (atc);
         drugie wywołanie open() przy już otwartej szufladzie (optymistyczne otwarcie + renderContents) się nie liczy */
      if (!this.classList.contains("active") && typeof window.svTrack === "function") {
        const svIcon = !!(triggeredBy && triggeredBy.id === "cart-icon-bubble");
        window.svTrack("sv_cart_open", { ui_from: svIcon ? (document.querySelector("cart-items") ? "cart_page" : "header") : "atc" });
      }
      document.body.classList.add("overflow-hidden");
      this.classList.add("animate", "active");
      const cartDrawerItems = this.querySelector("cart-drawer-items");
      if (cartDrawerItems) {
        cartDrawerItems.updateCartUpsellToggleState();
        cartDrawerItems.updateCartUpsellVisibility();
      }
      // Dispatch cart:open event
      document.dispatchEvent(new CustomEvent('cart:open'));
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
  }

  close() {
    clearTimeout(this.svOpenTimer); // BUG-overlay 30.09: zaplanowane otwarcie nie wraca po zamknięciu
    this.svOpenTimer = null;
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
    if (this.svPadded) {
      document.body.style.paddingRight = "";
      this.svPadded = false;
    }
  }

  /* OBS-1 30.09: menu nagłówka (hamburger) otwarte pod szufladą zostawało otwarte po jej zamknięciu. Zamyka je metoda motywu
     (HeaderDrawer.closeMenuDrawer z global.js: klasy menu, overflow-hidden-<breakpoint> na <body>, menu-open nagłówka,
     animacja zamknięcia). aria-expanded ustawiamy tu, bo metoda robi to tylko przy klawiaturze (przy kliknięciu robi to
     nasłuch podsumowań w global.js); bez tego zostałoby przyciemnienie pod nagłówkiem (::before przy aria-expanded=true). */
  closeHeaderMenu() {
    document.querySelectorAll("header-drawer").forEach((menu) => {
      const details = menu.mainDetailsToggle;
      if (!details || !details.hasAttribute("open") || typeof menu.closeMenuDrawer !== "function") return;
      const summary = details.querySelector("summary");
      if (!summary) return;
      try {
        menu.closeMenuDrawer(new Event("sv-cart-open"), summary);
      } catch (e) {}
      summary.setAttribute("aria-expanded", "false");
    });
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      /* BUG-overlay 30.09: klientka zamknęła optymistyczną szufladę (B-20), zanim sklep potwierdził dodanie — nowa treść
         wchodzi bez ponownego otwierania (licznik w ikonie koszyka odświeża się jak zwykle). Znacznik ustawia finish() niżej. */
      const skipOpen = this.svSkipOpen && Date.now() - this.svSkipOpen < 2000;
      this.svSkipOpen = 0;
      if (!skipOpen) this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);


/* perf 2026-10 B-20 (pakiet 2): optymistyczna szuflada przy „Dodaj do koszyka” (wzorzec Shopify). Po wysłaniu formularza
   produktu szuflada otwiera się od razu, a nie dopiero po odpowiedzi /cart/add (0,4–0,9 s). product-form.js dalej wysyła
   i rysuje szufladę jak dotąd; ten kod tylko nasłuchuje: koniec = cartUpdate/cartError z product-form (publikowane przed
   renderContents), zapas = 10 s. Kasa na ten czas czeka przez bramkę z cart-gift.js (window.svCheckoutHold, B3) — bez niej
   (np. B2B bez prezentu) nie ma optymistycznego otwarcia. Karty w szufladzie, szybkie dodanie (okno), zestawy i przejście
   prosto do kasy: bez zmian.
   T6 (01.10): zamiast białego panelu z napisem „Dodajemy do koszyka…” szkielet gotowego koszyka (<template id="CartDrawer-AtcPending">
   w cart-drawer.liquid): pusty koszyk = nagłówek, pasek dostawy, wiersz pozycji i stopka z paskami; niepusty = sam wiersz na górze
   listy. W wierszu zdjęcie wybranego wariantu i nazwa produktu z karty, z której klientka dodaje. Zdjęcie ma ten sam adres co
   zdjęcie pozycji w gotowej szufladzie (featured_image wariantu + width=300, jak image_url: width: 300 w cart-drawer.liquid),
   więc gotowy wiersz bierze je z pamięci przeglądarki. Bez danych (inny układ karty, zmiana wariantu w toku) zostają paski.
   W zadaniu kliknięcia: klon szablonu, kilka querySelector w obrębie karty i jeden JSON.parse, bez odczytów układu. */
(function () {
  if (window.__svAtcOptimistic) return;
  window.__svAtcOptimistic = true;
  let state = null;

  function finish(ok) {
    if (!state) return;
    const s = state;
    state = null;
    clearTimeout(s.timer);
    clearInterval(s.poll);
    const drawer = document.querySelector("cart-drawer");
    if (drawer) {
      drawer.classList.remove("sv-atc-pending");
      drawer.querySelectorAll("[data-sv-atc-pending]").forEach((el) => el.remove());
      if (!ok && !s.wasOpen && drawer.classList.contains("active")) drawer.close();
      /* BUG-overlay 30.09: zamknięta w trakcie dodawania = klientka ją zamknęła; product-form zaraz wywoła renderContents() */
      if (ok && !drawer.classList.contains("active")) drawer.svSkipOpen = Date.now();
    }
    s.release();
  }

  /* zdjęcie i nazwa do szkieletu: karta produktu (product-info: JSON wybranego wariantu + tytuł) albo kafel z szybkim dodaniem */
  function fillSkeleton(node, form, productForm, variantId) {
    const img = node.querySelector("[data-sv-skel-img]");
    const title = node.querySelector("[data-sv-skel-title]");
    const info = form.closest("product-info");
    const card = info ? null : form.closest(".card-wrapper, .card, li");
    const scope = info || card;
    if (!scope) return;
    let src = "";
    let w = 0;
    let h = 0;
    if (info && !productForm.variantPending) {
      const selected = info.querySelector("variant-selects [data-selected-variant]");
      if (selected) {
        try {
          const v = JSON.parse(selected.textContent);
          const fi = v && String(v.id) === String(variantId) ? v.featured_image : null;
          if (fi && fi.src) {
            src = fi.src + (fi.src.indexOf("?") > -1 ? "&" : "?") + "width=300";
            w = fi.width;
            h = fi.height;
          }
        } catch (e) {}
      }
    }
    /* produkt bez wariantów (brak variant-selects) albo wariant bez zdjęcia: pierwsze zdjęcie karty; w trakcie zmiany wariantu
       (A-06) bez zdjęcia, bo galeria może jeszcze pokazywać poprzedni kolor */
    if (!src && !productForm.variantPending) {
      const el = scope.querySelector(info ? ".product__media img" : ".card__media img, .card__inner img");
      if (el && (el.currentSrc || el.src)) {
        src = el.currentSrc || el.src;
        w = el.naturalWidth || el.width;
        h = el.naturalHeight || el.height;
      }
    }
    if (img && src) {
      if (w > 0 && h > 0) img.height = Math.ceil((150 * h) / w);
      img.addEventListener("load", () => img.classList.add("is-loaded"), { once: true });
      img.src = src;
      img.hidden = false;
    }
    const t = info
      ? info.querySelector(".product__title h1") || info.querySelector(".product__title")
      : scope.querySelector(".card__heading a") || scope.querySelector(".card__heading");
    const name = t ? t.textContent.trim() : "";
    if (title && name) title.textContent = name;
  }

  document.addEventListener(
    "submit",
    (event) => {
      if (state) return;
      const form = event.target;
      if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
      if (typeof window.svCheckoutHold !== "function") return;
      const drawer = document.querySelector("cart-drawer");
      const productForm = form.closest("product-form");
      if (!drawer || !productForm || productForm.cart !== drawer) return;
      if (form.closest("cart-drawer, quick-add-modal, quick-add-bulk, .bundle-deals")) return;
      /* K2 (10.10, c-zestaw): karty na stronie /cart nie otwierają szuflady (product-form.js odświeża stronę) */
      if (form.closest("#MainContent") && document.querySelector("cart-items")) return;
      const button = productForm.submitButton;
      if (button && button.getAttribute("aria-disabled") === "true") return;
      const idInput = form.querySelector('[name="id"]');
      if (!idInput || idInput.disabled || idInput.dataset.skipCart === "true") return;
      const template = drawer.querySelector("template#CartDrawer-AtcPending");
      if (!template) return;

      let node;
      if (drawer.classList.contains("is-empty")) {
        const inner = drawer.querySelector(".drawer__inner");
        const skeleton = template.content.querySelector(".sv-atc-skel");
        if (!inner || !skeleton) return; // stary szablon (okno wgrywania): bez optymistycznego otwarcia, jak natywnie
        node = skeleton.cloneNode(true);
        fillSkeleton(node, form, productForm, idInput.value);
        inner.insertBefore(node, inner.firstChild);
      } else {
        const tbody = drawer.querySelector(".cart-items tbody");
        const row = template.content.querySelector("tr");
        if (!tbody || !row) return;
        node = row.cloneNode(true);
        fillSkeleton(node, form, productForm, idInput.value);
        node.querySelectorAll(".loading__spinner").forEach((spinner) => spinner.classList.remove("hidden")); // stary szablon
        tbody.insertBefore(node, tbody.firstChild);
      }

      state = { release: window.svCheckoutHold(), wasOpen: drawer.classList.contains("active") };
      state.timer = setTimeout(() => finish(false), 10000);
      /* A-06 (product-form.js): dotknięcie w trakcie pobierania nowego wariantu czeka w kolejce; gdy nowy wariant okaże się
         niedostępny, dodanie przepada bez cartUpdate/cartError - wtedy szkielet znika od razu, a nie po 10 s */
      if (productForm.variantPending) {
        state.poll = setInterval(() => {
          if (!productForm.variantPending && !productForm.submitQueued && !(button && button.classList.contains("loading"))) finish(false);
        }, 150);
      }
      drawer.classList.add("sv-atc-pending");
      drawer.open(button || undefined);
    },
    true
  );

  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event && event.source === "product-form") finish(true);
    });
    subscribe(PUB_SUB_EVENTS.cartError, (event) => {
      if (event && event.source === "product-form") finish(false);
    });
  }
})();
